import { RiveNavIcon } from "./RiveNavIcon";

export const Notification = () => {
    return <RiveNavIcon artboard="Alert" inputName="alert" />;
}

export const NotificationFilled = () => {
    return <RiveNavIcon artboard="Alert" inputName="alert" active />;
}

export const NotificationFilledBG = () => {
    return (
        <svg width="83" height="82" viewBox="0 0 83 82" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2.19434" y="1.5" width="78.6062" height="78.6062" rx="39.3031" fill="#E50AAC" stroke="white" strokeWidth="3" />
            <path d="M20 17H22V19H2V17H4V10C4 7.87827 4.84285 5.84344 6.34315 4.34315C7.84344 2.84285 9.87827 2 12 2C14.1217 2 16.1566 2.84285 17.6569 4.34315C19.1571 5.84344 20 7.87827 20 10V17ZM9 21H15V23H9V21Z" fill="white" transform="translate(25, 25) scale(1.3)"/>
        </svg>
    )
}
